import React, { useState, useEffect } from 'react';
import { createTerminal, fetchPortsList } from './services/api';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Card, Alert, Container, Spinner } from 'react-bootstrap';
import { useAuth } from './AuthContext';

const CreateTerminal: React.FC = () => {
  const [name, setName] = useState('');
  const [port, setPort] = useState<number | ''>('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [geofenceArea, setGeofenceArea] = useState('');
  const [ports, setPorts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { token } = useAuth();

  useEffect(() => {

    if (token && token.designation?.user_type === 'ADMIN' && token.port) {
      setPort(token.port);
    }
  }, [token]);

  useEffect(() => {
    getPorts();
  }, []);

  async function getPorts() {
    const result = await fetchPortsList();
    console.log(result.data);
    setPorts(result.data);
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await createTerminal({
        name,
        port: Number(port),
        latitude: Number(latitude),
        longitude: Number(longitude),
        geofence_area: Number(geofenceArea)
      });
      setSuccess(true);
      setTimeout(() => navigate('/terminals'), 1200);
    } catch (err) {
      setError('Failed to create terminal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="p-4 p-md-5" style={{ maxWidth: 500 }}>
      <Card className="shadow-lg mt-4">
        <Card.Body>
          <h2 className="mb-4">Create Terminal</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" value={name} onChange={e => setName(e.target.value)} required maxLength={50} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="port">
              <Form.Label>Location</Form.Label>
              <Form.Select value={port} onChange={e => setPort(e.target.value === '' ? '' : Number(e.target.value))} required disabled={!!(token && token.designation?.user_type === 'ADMIN' && token.port)}>
                <option value="">Select Location</option>
                {ports.length > 0 ? ports.map((p: any) => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                )) : <option disabled>No ports available</option>}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="latitude">
              <Form.Label>Latitude</Form.Label>
              <Form.Control type="number" value={latitude} onChange={e => setLatitude(e.target.value)} required step="any" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="longitude">
              <Form.Label>Longitude</Form.Label>
              <Form.Control type="number" value={longitude} onChange={e => setLongitude(e.target.value)} required step="any" />
            </Form.Group>
            <Form.Group className="mb-4" controlId="geofenceArea">
              <Form.Label>Geofence Area (meters)</Form.Label>
              <Form.Control type="number" value={geofenceArea} onChange={e => setGeofenceArea(e.target.value)} required min={1} />
            </Form.Group>
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">Terminal created!</Alert>}
            <div className="d-flex justify-content-between">
              <Button type="button" variant="secondary" onClick={() => navigate('/terminals')} disabled={loading}>Back to List</Button>
              <Button type="submit" variant="primary" disabled={loading}>{loading ? <Spinner size="sm" animation="border" /> : 'Create Terminal'}</Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CreateTerminal; 